import { useContext } from 'react';
import { ServiceContext } from '../providers/services.js';

const useService = service => {
  const urls = useContext(ServiceContext);
  return urls?.[service]?.[0] ?? null;
};
const useBaseService = service => {
  const urls = useContext(ServiceContext);
  return urls?.[service]?.[0] ?? null;
};

export { useBaseService, useService };
//# sourceMappingURL=use-service.js.map
